import { useEffect, useRef, useState, type FormEvent } from 'react';
import { X } from 'lucide-react';
import { platformLabels, type PatrolSettings } from '@ailan/contracts';

type Props = {
  settings: PatrolSettings;
  open: boolean;
  saving: boolean;
  onClose: () => void;
  onSave: (settings: PatrolSettings) => void;
};

export function SettingsDialog({ settings, open, saving, onClose, onSave }: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [draft, setDraft] = useState(settings);

  useEffect(() => setDraft(settings), [settings]);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    onSave(draft);
  };

  return (
    <dialog ref={dialogRef} onClose={onClose}>
      <form onSubmit={submit}>
        <header className="dialogHead"><h2>巡店预警规则</h2><button type="button" className="iconButton" onClick={onClose} aria-label="关闭"><X /></button></header>
        <div className="dialogBody">
          <div className="settingsTop">
            <label>自动巡店间隔<input type="number" min="1" max="1440" value={draft.intervalMinutes} onChange={(event) => setDraft({ ...draft, intervalMinutes: Number(event.target.value) })} /></label>
            <label className="checkLabel"><input type="checkbox" checked={draft.enabled} onChange={(event) => setDraft({ ...draft, enabled: event.target.checked })} />开启后台自动巡店</label>
          </div>
          <div className="policyTable">
            <div className="policyHeader"><span>平台</span><span>最低满意率</span><span>最长回复时长</span><span>最晚登录</span></div>
            {draft.policies.map((policy, index) => (
              <div className="policyRow" key={policy.platform}>
                <strong>{platformLabels[policy.platform]}</strong>
                <label><input type="number" min="0" max="100" step="0.1" value={policy.minSatisfaction} onChange={(event) => setDraft({ ...draft, policies: draft.policies.map((item, itemIndex) => itemIndex === index ? { ...item, minSatisfaction: Number(event.target.value) } : item) })} /><span>%</span></label>
                <label><input type="number" min="1" max="600" value={policy.maxReplySeconds} onChange={(event) => setDraft({ ...draft, policies: draft.policies.map((item, itemIndex) => itemIndex === index ? { ...item, maxReplySeconds: Number(event.target.value) } : item) })} /><span>秒</span></label>
                <input type="time" value={policy.loginDeadline} onChange={(event) => setDraft({ ...draft, policies: draft.policies.map((item, itemIndex) => itemIndex === index ? { ...item, loginDeadline: event.target.value } : item) })} />
              </div>
            ))}
          </div>
        </div>
        <footer className="dialogFoot"><button type="button" className="button" onClick={onClose}>取消</button><button type="submit" className="button primary" disabled={saving}>{saving ? '保存中...' : '保存规则'}</button></footer>
      </form>
    </dialog>
  );
}
